
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/icc-rankings/men",
      function () {
        return require("private-next-pages/icc-rankings/men/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/icc-rankings/men"])
      });
    }
  